<script setup lang="ts">
import type Schema from "~/types/Schema";
import type { PropType } from "vue";
import plantumlEncoder from "plantuml-encoder";

const props = defineProps({
  schema: {
    type: Object as PropType<Schema>,
    required: true,
  },
});
const encoded = plantumlEncoder.encode(`@startjson\n${props.schema.jsonSchemaValidation}\n@endjson`);
const url = `https://planttext.com/api/plantuml/png/${encoded}`;
</script>

<template>
  <div class="">
    <a :href="url" target="_blank"><img :src="url" alt="Visualized image" /></a>
  </div>
</template>

<style scoped></style>
